import React from 'react'
import { Text } from '@mindfulchefuk/design-system'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { dateFormats } from '@mindfulchefuk/lib/dateFormats'

export const OnboardingCartDrawerDeliverySummary = () => {
  const { selectedPortionCount, expectedPaymentDate } =
    useChooseRecipesContext()
  const formattedPaymentDate =
    dateFormats.fullWeekdayAbbvMonthDay(expectedPaymentDate)

  return (
    <div>
      <Text variant="body-lg-500-caps" color="aubergine" pr={12} mb={8}>
        Your {selectedPortionCount} person recipes
      </Text>
      <Text
        as="p"
        variant="body-md"
        color="aubergine"
        data-testid="cart-drawer-recipes-copy"
      >
        {`Confirm below and we'll take payment on ${formattedPaymentDate}`}
      </Text>
    </div>
  )
}
